<template>  
  <div class="norem-mask">
    <div class="norem-verifybox">
      <div class="norem-verifybox-top">
        请完成安全验证
        <span class="norem-verifybox-close" @click="closePop"><van-icon name="cross" /></span>
      </div>
      <div class="norem-verifybox-body">
        <div id="slideVerify" class="norem-slide-verify" :style="widthlable" onselectstart="return false;">
          <!-- <canvas ref="canvasStr" id="canvasStr" :style="{width:w+'px',height:h+'px'}" /> -->
          <!-- <div class="verify-img-panel" ref="canvasStr" id="canvasStr" :style="{width:w+'px',height:h+'px',backgroundImage:`url(${imgurl})`,}"></div> -->
          <van-image 
            :src="imgurl"
            ref="canvasStr" 
            id="canvasStr"
            :style="{width:w+'px',height:h+'px'}">
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
          <!-- <canvas ref="block" id="block" class="slide-verify-block" :width="w" :height="h" /> -->
          <!-- <div class="verify-refresh" @click="refresh"><i class="iconfont icon-refresh"></i></div> -->
          <div class="norem-slide-verify-refresh-icon el-icon-refresh" @click="refresh">
            <i class="iconfont icon-refresh"></i>
          </div>
          <div class="norem-norem-slide-verify-info" id="verifyInfo" :class="{'norem-fail': fail, 'norem-show': showInfo}">{{infoText}}</div>
          <div
            class="norem-slide-verify-slider"
            :style="widthlable"
            :class="{'norem-container-active': containerActive, 'norem-container-success': containerSuccess, 'norem-container-fail': containerFail}"
          >
            <div class="norem-slide-verify-slider-mask" id="sliderMask" :style="{width: sliderMaskWidth}">
              <!-- slider -->
              <div
                id="slideHand"
                class="norem-slide-verify-slider-mask-item"
                :style="{left: sliderLeft}"
                @mousedown="sliderDown"
                @touchstart="touchStartEvent"
                @touchmove="touchMoveEvent"
                @touchend="touchEndEvent"
              >
                <div class="norem-slide-verify-slider-mask-item-icon el-icon-s-unfold">
                  <i  class="verify-icon iconfont icon-right"></i>
                  <div class="norem-verify-sub-block" id="block" :style="{width:sw+'px',height:sh+'px',top:-(207-blocky)+'px',backgroundImage:`url(${miniimgurl})`,}"></div>
                </div>
              </div>
            </div>
            <span class="norem-slide-verify-slider-text">{{ sliderText }}</span>
          </div>
        </div>
      </div>
      <!-- <button class="btn" @click="handleClick">在父组件可以点我刷新哦</button> -->
      <!-- <div>{{ msg }}</div> -->
    </div>
  </div>

  
</template>
<script>

import { reactive, defineComponent, onMounted, ref, watch } from "vue";

function sum(x, y) {
  return x + y
}

function square(x) {
  return x * x
}
export default {
  name: 'SlideVerify',
  emits: ['refresh', 'success', 'hideverify'],
  props: {
    // block length
    l: {
      type: Number,
      default: 42
    },
    // block radius
    r: {
      type: Number,
      default: 10
    },
    // canvas width
    w: { // 背景图宽
      type: [Number, String],
      default: 350
    },
    // canvas height
    h: { // 背景图高
      type: [Number, String],
      default: 200
    },
    // canvas width
    sw: { // 小图宽
      type: [Number, String],
      default: 40
    },
    // canvas height
    sh: {
      type: [Number, String],
      default: 50
    },
    // block_x: {
    //   type: Number,
    //   default: 155
    // },
    blocky: { // 小图初始的垂直距离
      type: [Number, String],
      default: 20
    },
    sliderText: {
      type: String,
      default: 'Slide filled right'
    },
    imgurl: { // 大图地址
      type: String,
      default: ''
    },
    miniimgurl: { // 小图地址
      type: String,
      default: ''
    },
    fresh: {
      type: Boolean,
      default: false
    }
  },
  setup(props,ctx) {
    const infoText = ref("");
    const state = reactive({
      containerActive: false, // container active class
      containerSuccess: false, // container success class
      containerFail: false, // container fail class
      canvasCtx: null,
      blockCtx: null,
      block: null,
      canvasStr: null,
      slideHand: null,  //滑柄
      verifyInfo: null, //消息
      sliderMask: null,
      // block_x: undefined, // container random position
      // blocky: undefined,
      L: props.l + props.r * 2 + 3, // block real lenght
      img: undefined,
      originX: undefined,
      originY: undefined,
      isMouseDown: false,
      trail: [],
      widthlable: '',
      sliderLeft: '0px', // block right offset
      sliderMaskWidth: '10px', // mask width
      dialogVisible: false,
      // infoText: '验证成功',
      fail: false,
      showInfo: false
    }) 
    // 监视ref所定义的一个响应式数据
    watch('fresh', (newValue, oldValue) => {
      console.log("fresh ==> ", newValue, oldValue);
      if (newValue) {
        init()
      }
    })    
    onMounted(() => {
      // 当界面挂载出来后就会自动执行
      // console.log(canvasStr.value);
      // 随机生成数this.block_x =
      init()
    })
    
    const init = () => {
      initDom()
      bindEvents()
      state.widthlable = 'width:' + props.w + 'px;'
    }
    const initDom = () => {
      state.block = document.getElementById('block');
      state.canvasStr = document.getElementById('canvasStr');
      state.slideHand = document.getElementById('slideHand');
      state.verifyInfo = document.getElementById('verifyInfo');
      state.sliderMask = document.getElementById('sliderMask');
      
      // state.canvasCtx = document.getElementById('canvasStr').getContext('2d');
      // state.blockCtx = document.getElementById('block').getContext('2d');
      // if(canvasStr.value){
      //   state.canvasCtx = canvasStr.value?.getContext('2d')
      // }
      // if(block.value){
      //   state.blockCtx = block.value?.getContext('2d')
      // }
      initImg()
    }

    const initImg = (h) => {
      // var that = this
      // const img = document.createElement('img')
      // img.onload = onload
      // img.onerror = () => {
      //   img.src = props.imgurl
      // }
      // img.src = props.imgurl
      // img.onload = function() {
      //   state.canvasCtx.drawImage(img, 0, 0, props.w, props.h)
      // }

      // state.img = img
      // const img1 = document.createElement('img')
      // var blockCtx = state.blockCtx
      // var blocky = h || props.blocky
      // if (blocky === 0) {
      //   return
      // }
      // img1.onerror = () => {
      //   img1.src = props.miniimgurl
      // }
      // img1.src = props.miniimgurl
      // img1.onload = function() {
      //   blockCtx.drawImage(img1, 0, blocky, props.sw, props.sh)
      //   // blockCtx.drawImage(img1, 0, blocky, 55, 45)
      // }
      // console.log(777, h)
    }
    // 刷新
    const refresh = () => {
      ctx.emit('refresh')
    }
    const sliderDown = (event) => {
      state.originX = event.clientX
      state.originY = event.clientY
      state.isMouseDown = true
    }
    const touchStartEvent = (e) => {
      state.originX = e.changedTouches[0].pageX
      state.originY = e.changedTouches[0].pageY
      state.isMouseDown = true
    }
    const bindEvents = () => {
      document.addEventListener('mousemove', e => {
        if (!state.isMouseDown) return false
        const moveX = e.clientX - state.originX
        const moveY = e.clientY - state.originY
        if (moveX < 0 || moveX + 40 >= props.w){
          return false
        } 
        state.sliderLeft = moveX + 'px'
        const blockLeft = ((props.w - 40 - 20) / (props.w - 40)) * moveX
        // state.block.style.left = blockLeft + 'px'
        state.slideHand.style.left = blockLeft + 'px'
        state.containerActive = true // add active
        state.sliderMaskWidth = moveX + 'px'
        state.sliderMask.style.width = moveX + 'px'
        state.trail.push(moveY)
      })
      document.addEventListener('mouseup', e => {
        if (!state.isMouseDown) return false
        state.isMouseDown = false
        if (e.clientX === state.originX) return false
        state.containerActive = false // remove active
        verify()
      })
    }
    const touchMoveEvent = (e) => {
      if (!state.isMouseDown) return false
      const moveX = e.changedTouches[0].pageX - state.originX
      const moveY = e.changedTouches[0].pageY - state.originY
      if (moveX < 0 || moveX + 20 >= props.w) {
        return false
      }
      state.sliderLeft = moveX + 'px'
      const blockLeft = ((props.w - 40 - 20) / (props.w - 40)) * moveX
      // state.block.style.left = blockLeft + 'px'
      state.slideHand.style.left = blockLeft + 'px'

      state.containerActive = true
      state.sliderMaskWidth = moveX + 'px'
      state.sliderMask.style.width = moveX + 'px'
      state.trail.push(moveY)
    }
    const touchEndEvent = (e) => {
      if (!state.isMouseDown) return false
      state.isMouseDown = false
      if (e.changedTouches[0].pageX === state.originX) {
        return false
      }
      state.containerActive = false
      verify()
    }
    const verify = () => {
      const arr = state.trail // drag y move distance
      const average = arr.reduce(sum) / arr.length // average
      const deviations = arr.map(x => x - average) // deviation array
      const stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length) // standard deviation
      const left = parseInt(state.slideHand.style.left)
      ctx.emit('success', left, stddev)
    }
    const reset = (h) => {
      state.containerActive = false
      state.containerSuccess = false
      state.containerFail = false
      state.sliderLeft = '0px'
      // state.block.style.left = '0px'
      state.slideHand.style.left = '0px'
      state.sliderMaskWidth = '0px'
      state.sliderMask.style.width = '0px'
      // state.canvasCtx.clearRect(0, 0, props.w, props.h)
      // state.blockCtx.clearRect(0, 0, props.w, props.h)
      state.fail = false
      state.showInfo = false
      state.verifyInfo.style.display = 'none'
      state.containerFail = false
      state.containerSuccess = false
      initImg(h)
    }
    const handleFail = (msg) => {
      state.fail = true
      state.showInfo = true
      infoText.value = msg||'验证失败';
      // state.infoText = msg||'验证失败'
      state.verifyInfo.style.display = 'block';
      state.verifyInfo.classList.add('norem-fail','norem-show');
      state.containerFail = true
    }
    const handleSuccess = () => {
      // console.log(777)
      state.showInfo = true
      // infoText.value = '验证成功';
      // state.infoText = '验证成功'
      state.verifyInfo.style.display = 'block'
      state.verifyInfo.classList.remove('norem-fail');
      state.verifyInfo.textContent = '验证成功';
      state.containerSuccess = true
      // setTimeout(() => {
      //   state.block.style.left = '0px'
      //   state.sliderMaskWidth = '0px'
      //   state.sliderMask.style.width = '0px'
      //   state.sliderLeft = '0px'
      //   state.fail = false
      //   state.showInfo = false
      //   state.containerSuccess = false
      // }, 1000)
    }
    //关闭弹窗
    const closePop = () => {
      ctx.emit('hideverify');      
    };

    return {
      infoText,
      init,
      initDom,
      initImg,
      refresh,
      sliderDown,
      touchStartEvent,
      bindEvents,
      touchMoveEvent,
      touchEndEvent,
      verify,
      reset,
      handleFail,
      handleSuccess,
      closePop
    };
  },
}

</script>
<style lang="less" scoped>
  @import '../assets/style/mixin';
  *{margin:0;padding:0;}
  /*字体图标的css*/
  @font-face {
      font-family: "iconfont";
      src: url('../assets/fonts/iconfont.eot?t=1508229193188'); /* IE9*/
      src: url('../assets/fonts/iconfont.eot?t=1508229193188#iefix') format('embedded-opentype'), /* IE6-IE8 */
      url('data:application/x-font-woff;charset=utf-8;base64,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') format('woff'), 
      url('../assets/fonts/iconfont.ttf?t=1508229193188') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/
      url('../assets/fonts/iconfont.svg?t=1508229193188#iconfont') format('svg'); /* iOS 4.1- */
  }

  .iconfont {
      font-family: "iconfont" !important;
      font-size: 16px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  }

  .icon-check:before {
      content: "\e645";
  }

  .icon-close:before {
      content: "\e646";
  }

  .icon-right:before {
      content: "\e6a3";
  }

  .icon-refresh:before {
      content: "\e6a4";
  }

  .norem-mask{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1001;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,.3);
    transition: all .5s;
  }
  .norem-verifybox{
    width: 334px;
    position: relative;
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid #e4e7eb;
    background-color: #fff;
    box-shadow: 0 0 10px rgb(0 0 0 / 30%);
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .norem-verifybox-top{
    padding: 0 15px;
    height: 50px;
    line-height: 50px;
    text-align: left;
    font-size: 16px;
    color: #45494c;
    border-bottom: 1px solid #e4e7eb;
    box-sizing: border-box;
  }
  .norem-verifybox-close{
    position: absolute;
    top: 13px;
    right: 9px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
  }
  .norem-verifybox-body{
    box-sizing: border-box;
    position: relative;
    padding: 15px;
  }


  .norem-slide-verify {
    position: relative;
    width: 300px;
    overflow: hidden;
    font-size: 0;
    /* height: 210px; */
  }

  .slide-verify-block {
    position: absolute;
    left: 0;
    top: 0;
  }
  .verify-img-panel{
    margin: 0;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
    border-radius: 3px;
    position: relative;
  }

  .norem-slide-verify-refresh-icon {
    position: absolute;
    right: 0;
    top: 0;
    width: 34px;
    height: 34px;
    cursor: pointer;
    content: '刷新';
    font-size: 22px;
    line-height: 34px;
    text-align: center;
    font-weight: bold;
    color: #fff;
    /* background: url("../../assets/move/icon_light.png") 0 -437px; */
    background-size: 34px 471px;
  }
  .norem-slide-verify-refresh-icon:hover {
    transform: rotate(180deg);
    transition: all 0.2s ease-in-out;
  }

  .norem-slide-verify-slider {
    position: relative;
    text-align: center;
    /* width: 300px; */
    height: 40px;
    line-height: 40px;
    margin-top: 15px;
    background: #f7f9fa;
    color: #45494c;
    border: 1px solid #e4e7eb;
    font-size: 12px;
  }

  .norem-slide-verify-slider-mask {
    position: absolute;
    left: 0;
    top: 0;
    height: 40px;
    border: 0 solid #1991fa;
    background: #d1e9fe;
  }

  .norem-norem-slide-verify-info {
    display: none;
    position: absolute;
    top: 120px;
    left: 0;
    height: 30px;
    width: 100%;
    color: #fff;
    text-align: center;
    line-height: 30px;
    background-color: rgba(92, 184, 92,.5);
    filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=#7f5CB85C, endcolorstr=#7f5CB85C);
    font-size: 13px;
  }

  .norem-norem-slide-verify-info.norem-fail {
    /* background-color: #f57a7a; */
    background-color: rgba(217, 83, 79,.5);
    filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=#7fD9534F, endcolorstr=#7fD9534F);
  }
  .norem-norem-slide-verify-info.norem-show {
    animation: hide 1s ease;
  }
  @keyframes hide {
    0% {opacity: 0;}
    100% {opacity: 0.9;}
  }
  .norem-slide-verify-slider-mask-item {
    position: absolute;
    top: 0;
    /* left: 0; */
    width: 40px;
    height: 40px;
    background: #fff;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    transition: background 0.2s linear;
  }

  .norem-slide-verify-slider-mask-item:hover {
    background: #1991fa;
  }

  /* .norem-slide-verify-slider-mask-item:hover .norem-slide-verify-slider-mask-item-icon {
    background-position: 0 -13px;
  } */

  .norem-slide-verify-slider-mask-item-icon {
    position: relative;
    /* position: absolute;
    top: 9px;
    left: 7px;
    width: 14px;
    height: 12px;
    content: ''; */
    font-size: 22px;
    color: #000;
    /* text-align: center;
    line-height: 12px; */
    /* background: url("../../assets/move/icon_light.png") 0 -26px; */
    /* background-size: 34px 471px; */
  }
  .norem-container-active .norem-slide-verify-slider-mask-item {
    height: 38px;
    top: -1px;
    border: 1px solid #1991fa;
  }
  .norem-verify-sub-block{
    position: relative;
    text-align: center;
    z-index: 200;
    background-repeat: no-repeat;
  }
  .norem-container-active .norem-slide-verify-slider-mask {
    height: 38px;
    border-width: 1px;
  }

  .norem-container-success .norem-slide-verify-slider-mask-item {
    height: 38px;
    top: -1px;
    border: 1px solid #52ccba;
    background-color: #52ccba !important;
  }

  .norem-container-success .norem-slide-verify-slider-mask {
    height: 38px;
    border: 1px solid #52ccba;
    background-color: #d2f4ef;
  }

  .norem-container-success .norem-slide-verify-slider-mask-item-icon {
    background-position: 0 0 !important;
  }

  .norem-container-fail .norem-slide-verify-slider-mask-item {
    height: 38px;
    top: -1px;
    border: 1px solid #f57a7a;
    background-color: #f57a7a !important;
  }

  .norem-container-fail .norem-slide-verify-slider-mask {
    height: 38px;
    border: 1px solid #f57a7a;
    background-color: #fce1e1;
  }

  .norem-container-fail .norem-slide-verify-slider-mask-item-icon {
    top: 14px;
    background-position: 0 -82px !important;
  }

  .norem-container-active .norem-slide-verify-slider-text,
  .norem-container-success .norem-slide-verify-slider-text,
  .norem-container-fail .norem-slide-verify-slider-text {
    display: none;
  }
</style>
